import { AnimatePresence, motion } from 'motion/react';
import { useEffect, useState } from 'react';

import { useGetParams } from '../../hooks/useGetParams';
import { isCorrectLink } from '../../helpers/titreHelper';
import styles from './Photo.module.css';

import bgQuestionDefault from '../../assets/video/bgQuestion.webm';
import bgPosterQuestionDefault from '../../assets/images/bgPosterQuestion.webp';
import snowBig from '../../assets/images/snowBig.png';
import snowSmall from '../../assets/images/snowSmall.png';
import icePoster from '../../assets/images/icePoster.png';
import ice from '../../assets/video/ice.webm';

export const Photo = ({ currentState, message = {} }) => {
  const {
    bgVideoQuestion,
    bgPosterQuestion,
    bgImgQuestion,
    title,
    titleFontSize,
  } = useGetParams();

  const { content, attachments } = message;
  const url = attachments?.[0]?.url;

  const [curMessage, setCurMessage] = useState({ url, content });

  useEffect(() => {
    if (currentState === 'S1' && url !== curMessage?.url) {
      setCurMessage({ url, content });
    }
  }, [currentState, url, content]);

  const textLines = curMessage?.content?.split(/\r?\n/);
  const titleLines = title.split('\\n');

  return (
    <div className={styles.photoWrapper}>
      {currentState === 'S2' && (
        <div className={styles.iceBlock}>
          <video autoPlay="autoplay" muted="muted" poster={icePoster}>
            <source src={ice} type="video/webm" />
          </video>
        </div>
      )}

      <AnimatePresence mode="popLayout">
        {curMessage && (
          <motion.div
            className={styles.imgBlock}
            key={curMessage.url}
            initial={{ x: '-50vw' }}
            animate={{ x: currentState === 'S1' ? 0 : '50vw' }}
            exit={{ x: '100vw' }}
            transition={{ duration: 0.5 }}
          >
            {curMessage?.url && <img src={curMessage.url} alt="" />}

            <div className={styles.text}>
              {textLines && textLines[0] && (
                <div className={styles.firsLineBlock}>
                  <div className={styles.firsLine}>{textLines[0].trim()}</div>

                  <img src={snowBig} alt="snowBig" className={styles.snowBig} />
                  <img
                    src={snowSmall}
                    alt="snowBig"
                    className={styles.snowSmall}
                  />
                </div>
              )}
              {textLines && textLines[1] && (
                <div className={styles.secondLine}>{textLines[1].trim()}</div>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.div
        initial={{ x: '50vw' }}
        animate={{ x: 0 }}
        transition={{ duration: 0.5 }}
        className={styles.bgBlock}
      >
        {bgVideoQuestion &&
          (!bgImgQuestion || !isCorrectLink(bgImgQuestion)) && (
            <video
              autoPlay="autoplay"
              muted="muted"
              loop
              poster={
                bgVideoQuestion === '1'
                  ? bgPosterQuestionDefault
                  : bgPosterQuestion
              }
            >
              <source
                src={
                  bgVideoQuestion === '1' ? bgQuestionDefault : bgVideoQuestion
                }
              />
            </video>
          )}

        {bgImgQuestion && <img src={bgImgQuestion} alt="bg" />}

        <div
          className={styles.titleBlock}
          style={{ fontSize: `${titleFontSize}rem` }}
        >
          {titleLines &&
            titleLines.map((l, i) => (
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: [0, 1.05, 1] }}
                transition={{ duration: 1, delay: i * 0.5 + 0.7 }}
                key={l + i}
                className={styles.titleLine}
                style={{
                  '--wiggleDelay': `${i * 0.5 + (i % 2 ? 1.9 : 2.2)}s`,
                }}
              >
                {l}
              </motion.div>
            ))}
        </div>
      </motion.div>
    </div>
  );
};
